import React from 'react';
import { SmartphoneIcon, MonitorIcon, PaintBucketIcon, CodeIcon, ServerIcon } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <MonitorIcon size={32} className="text-blue-600" data-id="element-179" />,
    title: 'Web Development',
    description: 'Responsive, fast, and accessible websites and web platforms built with modern technologies.'
  }, {
    icon: <SmartphoneIcon size={32} className="text-red-500" data-id="element-180" />,
    title: 'Mobile Apps',
    description: 'Native and cross-platform mobile applications for iOS and Android.'
  }, {
    icon: <PaintBucketIcon size={32} className="text-yellow-500" data-id="element-181" />,
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive interfaces with clean and functional design principles.'
  }, {
    icon: <CodeIcon size={32} className="text-green-500" data-id="element-182" />,
    title: 'Custom Software',
    description: 'Bespoke software platforms and internal tools tailored to your specific business needs.'
  }, {
    icon: <ServerIcon size={32} className="text-indigo-500" data-id="element-183" />,
    title: 'Backend Systems',
    description: 'Robust, scalable backend infrastructure and API development.'
  }];
  const phases = [{
    number: '01',
    title: 'Discovery & design',
    description: 'We map what you actually need, what users actually do, and what success looks like before a single line of code is written.'
  }, {
    number: '02',
    title: 'Build & iterate',
    description: 'Short cycles, working software at every step, your team involved at every review.'
  }, {
    number: '03',
    title: 'Ship & support',
    description: 'We launch with you, hand over clean code and documentation, and stay close enough to fix the things you find in week one.'
  }];
  return <section id="services" className="py-20 bg-gray-50" data-id="element-184">
      <div className="container mx-auto px-4" data-id="element-185">
        <div className="text-center mb-16" data-id="element-186">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-187">
            Our Services
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6" data-id="element-188"></div>
          <p className="max-w-2xl mx-auto text-gray-600" data-id="element-189">
            Custom software, web, and mobile applications built with
            Scandinavian design principles.
          </p>
        </div>
        {/* Services grid */}
        <div className="mb-20" data-id="element-190">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-191">
            {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-192">
                <div className="mb-4" data-id="element-193">{service.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-194">
                  {service.title}
                </h3>
                <p className="text-gray-600" data-id="element-195">{service.description}</p>
              </div>)}
          </div>
        </div>
        {/* How we build */}
        <div className="mt-16 bg-white p-8 md:p-12 rounded-lg border border-gray-100 shadow-sm" data-id="element-196">
          <div className="flex flex-col md:flex-row gap-10" data-id="element-197">
            <div className="md:w-1/2 order-2" data-id="element-198">
              <h3 className="text-3xl font-bold text-gray-900 mb-5" data-id="element-199">
                How we build
              </h3>
              <p className="text-gray-600 mb-8 text-lg leading-relaxed" data-id="element-200">
                A simple, disciplined process that turns ideas into shipped
                products.
              </p>
              <ul className="space-y-6 mb-8" data-id="element-201">
                {phases.map(phase => <li key={phase.number} className="flex gap-4" data-id="element-202">
                    <span className="text-blue-600 font-bold text-lg flex-shrink-0 mt-0.5" data-id="element-203">
                      {phase.number}
                    </span>
                    <div data-id="element-204">
                      <h4 className="font-semibold text-gray-900 mb-1" data-id="element-205">
                        {phase.title}
                      </h4>
                      <p className="text-gray-600 leading-relaxed" data-id="element-206">
                        {phase.description}
                      </p>
                    </div>
                  </li>)}
              </ul>
              <a href="#contact" className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:text-blue-700 transition-colors" data-id="element-207">
                Discuss your project <span aria-hidden="true" data-id="element-208">→</span>
              </a>
            </div>
            <div className="md:w-1/2 order-1" data-id="element-209">
              <img src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80" alt="Code on a developer's screen" className="rounded-lg shadow-md w-full aspect-[4/3] object-cover" data-id="element-210" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}